export const SET_COLOR = 'SET_COLOR'
export const SEQUENCE_ADD = 'SEQUENCE_ADD'
export const LINE_ADD = 'LINE_ADD'
export const LINE_INCREMENT = 'LINE_INCREMENT'
export const RESET_STALKS = 'RESET_STALKS'
export const RESET_STALKS_CONTINUING = 'RESET_STALKS_CONTINUING'
export const LINE_OBSERVER = 'LINE_OBSERVER'
export const LINE_INITIALIZED = 'LINE_INITIALIZED'
export const LINE_DIVIDING = 'LINE_DIVIDING'
export const LINE_DIVISION_INCREMENT = 'LINE_DIVISION_INCREMENT'
export const LINE_STALKS_COUNT = 'LINE_STALKS_COUNT'
export const LINE_LH = 'LINE_LH'
export const LINE_RH = 'LINE_RH'
export const LINE_RESERVE = 'LINE_RESERVE'
export const LINE_COUNT = 'LINE_COUNT'
export const LINE_THRICE = 'LINE_THRICE'
